export default __webpack_public_path__ + "static/media/On way to Bandipur.cd9e92be.jpg";